/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class PressArticlesApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get the list of press articles
     * @param offset 
     * @param limit 
     */
    public all(offset?: number, limit?: number, __unused?: any): Observable<PagedArray<models.ApiPressArticle>> {
        const path = '/content/press/articles';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (offset !== undefined) {
            queryParameters['offset'] = <any>offset;
        }

        if (limit !== undefined) {
            queryParameters['limit'] = <any>limit;
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiPressArticle>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
